import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations'; //faq
import { HttpClient } from '@angular/common/http';
import { IpLocationService } from './ip-location.service';

interface QAItem {
    question: string;
    questionHindi: string;
    answer: string;
    answerHindi: string;
    category?: string;
    popularity?: number;
}
let mylocation = '',
    finallocation = '';
@Component({
    selector: 'app-chatboat',
    templateUrl: './chatboat.component.html',
    styleUrls: ['./chatboat.component.scss'],
    animations: [
        trigger('fadeIn', [
            // Changed from 'slideInOut' to 'fadeIn' to match template
            transition(':enter', [
                style({ opacity: 0, height: 0 }),
                animate('200ms ease-out', style({ opacity: 1, height: '*' })),
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, height: 0 })),
            ]),
        ]),
    ],
})
export class ChatboatComponent implements OnInit {
    @ViewChild('chatBox') chatBox!: ElementRef;
    @ViewChild('userInput') userInput!: ElementRef;

    messages: any[] = [
        {
            content:
                '<b>Hi, Welcome to Subharti University CDOE Student Portal</b> <p>Ask any academic question and get instant answers</p>',
            isUser: false,
            isTyping: false,
        },
    ];
    typing = false;
    showHindi = false;
    relatedQuestions: QAItem[] = [];
    minCharsForSuggestions = 2;
    qaList: QAItem[] = [];
    currentInput = '';
    keepSuggestions = false; // New flag to control suggestion visibility

    constructor(
        private http: HttpClient,
        private changeDetectorRef: ChangeDetectorRef, // Corrected parameter name
        private ipService: IpLocationService
    ) {}

    async ngOnInit() {
        this.loadQuestions();
        mylocation = await this.ipService.fetchIPDetails();
        if (mylocation != null) {
            finallocation =
                'Your IP: ' +
                mylocation['ip'] +
                ', City:' +
                mylocation['city'] +
                ', Region:' +
                mylocation['region'] +
                ', Country:' +
                mylocation['country'] +
                ', Location: ' +
                mylocation['location'] +
                ', Org:' +
                mylocation['org'] +
                ', PinCode:' +
                mylocation['postal'] +
                ', TimeZome:' +
                mylocation['timezone'];
        }
    }
    normalizeText(text: string | undefined | null): string {
        if (!text) return '';

        return text
            .toLowerCase()
            .replace(/[^\w\s\u0900-\u097F]/g, '') // विराम चिह्न हटाएं
            .replace(/सुभारती|subharti|Subharti/g, 'सुभारती')
            .replace(/डीडीई|dde/g, 'डीडीई')
            .replace(/CDOE|सीडीऔई/g, 'CDOE')
            .replace(
                /विश्वविद्यालय|university|vishwavidyalaya/g,
                'विश्वविद्यालय'
            )
            .replace(/क्या|kya|kaya|kaya/g, 'क्या')
            .replace(/है|hai/g, 'है')
            .replace(/प्रवेश|admission/g, 'प्रवेश')
            .replace(/पाठ्यक्रम|कोर्स|courses|programs/g, 'पाठ्यक्रम')
            .replace(/मान्यता|ugc/g, 'मान्यता')
            .replace(/परीक्षा|exam/g, 'परीक्षा')
            .replace(/परिणाम|result/g, 'परिणाम')
            .replace(/शुल्क|fees?/g, 'शुल्क')
            .replace(/आवेदन/g, 'आवेदन')
            .replace(/कैसे|how|How/g, 'कैसे')
            .replace(/क्या|What|kay|kaya|kya/g, 'क्या')
            .replace(/कब|Kab/g, 'कब')
            .replace(/योग्यता|eligibility/g, 'योग्यता')
            .replace(/डाक|postal/g, 'डाक')
            .replace(/\s+/g, ' ') // एक से अधिक स्पेस को एक स्पेस में बदलें
            .trim();
    }

    //FAQ
    //showHindi = false; // Make sure this exists

    faqItems = [
        {
            question: 'How do I ask a <b>question</b>?',
            questionHindi: '<b>प्रश्न</b> कैसे पूछें?',
            answer: 'Simply type your <b>question</b> in the input box at the bottom and press <i>Enter</i> or click the <i>send button</i>.',
            answerHindi:
                'नीचे दिए गए इनपुट बॉक्स में अपना <b>प्रश्न</b> टाइप करें और <i>एंटर</i> दबाएं या <i>भेजें बटन</i> पर क्लिक करें।',
            isExpanded: false,
        },
        {
            question: 'Can I ask in <b>Hindi</b>?',
            questionHindi: 'क्या मैं <b>हिंदी</b> में पूछ सकता हूँ?',
            answer: 'Yes! Click the <i>language toggle button</i> in the top right corner to switch between <b>English</b> and <b>Hindi</b>.',
            answerHindi:
                'हाँ! ऊपर दायें कोने में <i>भाषा बटन</i> पर क्लिक करके <b>अंग्रेजी</b> और <b>हिंदी</b> के बीच बदलें।',
            isExpanded: false,
        },
        {
            question: 'What kind of <b>questions</b> can I ask?',
            questionHindi: 'मैं किस तरह के <b>प्रश्न</b> पूछ सकता हूँ?',
            answer: 'You can ask about <b>admissions</b>, <b>courses</b>, <b>fees</b>, <b>exams</b>, <b>results</b>, and any other <i>academic-related queries</i>.',
            answerHindi:
                'आप <b>प्रवेश</b>, <b>पाठ्यक्रम</b>, <b>शुल्क</b>, <b>परीक्षा</b>, <b>परिणाम</b> और किसी भी अन्य <i>शैक्षणिक संबंधित प्रश्न</i> पूछ सकते हैं।',
            isExpanded: false,
        },
        {
            question: 'Is there a limit to questions I can ask?',
            questionHindi:
                'क्या मैं <b>सीमित संख्या</b> में प्रश्न पूछ सकता हूँ?',
            answer: 'No, you can ask <b>unlimited questions</b>. Our <i>chat assistant</i> is available <b>24/7</b> to help you.',
            answerHindi:
                'नहीं, आप <b>असीमित प्रश्न</b> पूछ सकते हैं। हमारा <i>चैट सहायक</i> आपकी सहायता के लिए <b>24/7</b> उपलब्ध है।',
            isExpanded: false,
        },
        {
            question: 'How <b>accurate</b> are the answers?',
            questionHindi: 'उत्तर कितने <b>सटीक</b> हैं?',
            answer: 'Our answers are based on <b>official university information</b> and are <i>regularly updated</i> for accuracy.',
            answerHindi:
                'हमारे उत्तर <b>विश्वविद्यालय की आधिकारिक जानकारी</b> पर आधारित हैं और <i>सटीकता</i> के लिए नियमित रूप से अद्यतन किए जाते हैं।',
            isExpanded: false,
        },
        {
            question: 'Can I get information about <b>course fees</b>?',
            questionHindi:
                'क्या मुझे <b>पाठ्यक्रम शुल्क</b> के बारे में जानकारी मिल सकती है?',
            answer: "Yes, you can ask about <b>fees</b> for any course. For example: '<i>What is the fee for MBA program?</i>'",
            answerHindi:
                "हाँ, आप किसी भी पाठ्यक्रम के <b>शुल्क</b> के बारे में पूछ सकते हैं। उदाहरण: '<i>एमबीए कार्यक्रम का शुल्क क्या है?</i>'",
            isExpanded: false,
        },
        {
            question: 'How do I check my <b>exam results</b>?',
            questionHindi: 'मैं अपने <b>परीक्षा परिणाम</b> कैसे देख सकता हूँ?',
            answer: "You can ask '<i>How to check results for [exam name]?</i>' and we'll provide the <b>official link</b> and <i>steps</i>.",
            answerHindi:
                "आप पूछ सकते हैं '<i>[परीक्षा नाम] के परिणाम कैसे देखें?</i>' और हम <b>आधिकारिक लिंक</b> और <i>चरण</i> प्रदान करेंगे।",
            isExpanded: false,
        },
        {
            question: "What's the <b>admission process</b>?",
            questionHindi: '<b>प्रवेश प्रक्रिया</b> क्या है?',
            answer: "The process varies by program. Please specify which <b>course</b> you're interested in for <i>detailed steps</i>.",
            answerHindi:
                'प्रक्रिया <b>कार्यक्रम</b> के अनुसार अलग-अलग होती है। <i>विस्तृत चरणों</i> के लिए कृपया बताएं कि आप किस <b>पाठ्यक्रम</b> में रुचि रखते हैं।',
            isExpanded: false,
        },
        {
            question: 'Are <b>distance learning degrees</b> valid?',
            questionHindi: 'क्या <b>दूरस्थ शिक्षा की डिग्री</b> मान्य हैं?',
            answer: 'Yes, our <b>distance learning programs</b> are <b>UGC-approved</b> and <i>recognized throughout India</i>.',
            answerHindi:
                'हाँ, हमारे <b>दूरस्थ शिक्षा कार्यक्रम</b> <b>यूजीसी-अनुमोदित</b> हैं और <i>पूरे भारत में मान्यता प्राप्त</i> हैं।',
            isExpanded: false,
        },
        {
            question: 'How can I contact a <b>human representative</b>?',
            questionHindi:
                'मैं <b>मानव प्रतिनिधि</b> से कैसे संपर्क कर सकता हूँ?',
            answer: "Type '<b>contact representative</b>' and we'll provide <i>phone numbers and email</i> for direct assistance.",
            answerHindi:
                "'<b>प्रतिनिधि से संपर्क करें</b>' टाइप करें और हम <i>सीधी सहायता</i> के लिए <b>फोन नंबर</b> और <b>ईमेल</b> प्रदान करेंगे।",
            isExpanded: false,
        },
    ];

    toggleFaq(index: number): void {
        this.faqItems[index].isExpanded = !this.faqItems[index].isExpanded;
    }

    loadQuestions() {
        this.http.get<QAItem[]>('/assets/questions.json').subscribe(
            (data) => {
                this.qaList = data.map((item) => ({
                    ...item,
                    popularity: item.popularity || 0,
                }));
                this.updateWelcomeMessage();
            },
            (error) => {
                console.error('Error loading questions:', error);
                this.qaList = this.getDefaultQuestions();
                this.updateWelcomeMessage();
            }
        );
    }

    getDefaultQuestions(): QAItem[] {
        return [
            {
                question: 'What is Subharti University?',
                questionHindi: 'सुभारती यूनिवर्सिटी क्या है?',
                answer: 'Subharti University is a UGC-recognized university...',
                answerHindi:
                    'सुभारती यूनिवर्सिटी यूजीसी मान्यता प्राप्त विश्वविद्यालय है...',
                popularity: 100,
            },
            {
                question: 'What programs are offered?',
                questionHindi: 'कौन से पाठ्यक्रम उपलब्ध हैं?',
                answer: 'We offer BA, BCom, BSc programs...',
                answerHindi:
                    'हम बीए, बीकॉम, बीएससी कार्यक्रम प्रदान करते हैं...',
                popularity: 80,
            },
        ];
    }

    updateWelcomeMessage() {
        if (this.messages.length > 0) {
            this.messages[0].content = this.showHindi
                ? '<b>नमस्ते, सुभारती यूनिवर्सिटी सीडीओई पोर्टल में आपका स्वागत है</b><br/>कोई भी शैक्षणिक प्रश्न पूछें और तुरंत उत्तर प्राप्त करें.'
                : '<b>Hi, Welcome to Subharti University CDOE Student Portal</b><br/>Ask any academic question and get instant answers.';
        }
    }

    onInputChange(event: any) {
        this.currentInput = event.target.value;
        if (this.currentInput.length >= this.minCharsForSuggestions) {
            this.updateSuggestions(this.currentInput);
        } else {
            this.relatedQuestions = [];
        }
        this.changeDetectorRef.detectChanges();
    }

    updateSuggestions(query: string) {
        try {
            const normalizedQuery = this.normalizeText(query);
            const langField = this.showHindi ? 'questionHindi' : 'question';

            this.relatedQuestions = this.qaList
                .map((item) => {
                    const questionText = this.normalizeText(item[langField]);
                    const alternateLangText = this.normalizeText(
                        this.showHindi ? item.question : item.questionHindi
                    );

                    let score = 0;

                    // Exact match in current language
                    if (questionText === normalizedQuery) score += 100;

                    // Contains in current language
                    if (questionText.includes(normalizedQuery)) score += 30;

                    // Match in alternate language
                    if (alternateLangText.includes(normalizedQuery))
                        score += 20;

                    // Count matching words
                    const queryWords = normalizedQuery.split(/\s+/);
                    const matchingWords = queryWords.filter(
                        (word) =>
                            questionText.includes(word) ||
                            alternateLangText.includes(word)
                    ).length;
                    score += matchingWords * 10;

                    return { ...item, score };
                })
                .filter((item) => item.score > 0)
                .sort((a, b) => b.score - a.score)
                .slice(0, 5)
                .map(({ score, ...rest }) => rest);
        } catch (error) {
            console.error('सुझाव अपडेट करने में त्रुटि:', error);
            this.relatedQuestions = [];
        }
        this.changeDetectorRef.detectChanges();
    }

    extractKeywords(question: string): string[] {
        // Simple implementation - customize as needed
        const stopWords = [
            'what',
            'are',
            'the',
            'after',
            'at',
            'is',
            'of',
            'in',
        ];
        return question
            .toLowerCase()
            .split(/\s+/)
            .filter((word) => word.length > 3 && !stopWords.includes(word));
    }

    selectQuestion1(question: QAItem) {
        // Add the question to chat
        const langField = this.showHindi ? 'questionHindi' : 'question';
        this.addMessage(question[langField], true);

        // Show typing indicator
        this.typing = true;

        // Show answer after a short delay
        setTimeout(() => {
            this.typing = false;
            const answerField = this.showHindi ? 'answerHindi' : 'answer';
            this.addMessage(question[answerField], false);
        }, 500);

        this.currentInput = question[langField];
        this.userInput.nativeElement.value = this.currentInput;
        this.updateSuggestions(this.currentInput);
        this.userInput.nativeElement.focus();
    }

    selectQuestion(question: QAItem) {
        const langField = this.showHindi ? 'questionHindi' : 'question';
        const questionText =
            question[langField] ||
            question.question ||
            question.questionHindi ||
            '';
        this.currentInput = questionText;
        this.userInput.nativeElement.value = questionText;
        this.keepSuggestions = true; // Don't clear suggestions immediately
        this.userInput.nativeElement.focus();
        this.changeDetectorRef.detectChanges();
        this.currentInput;
        // Add the question to chat with typing animation
        this.addMessageWithAnimation(question[langField], true);
        this.addUserInputQuestion(questionText);
        // Show answer after a delay
        setTimeout(() => {
            const answerField = this.showHindi ? 'answerHindi' : 'answer';
            const answerText =
                question[answerField] ||
                question.answer ||
                question.answerHindi ||
                (this.showHindi
                    ? 'उत्तर उपलब्ध नहीं है'
                    : 'Answer not available');
            this.addMessageWithAnimation(answerText, false);
        }, 500);
    }
    addUserInputQuestion(question: string) {
        if (!question || question.trim() === '') return;

        // Encode the question for URL safety
        const encodedQuestion = encodeURIComponent(question);
        //https://ums.subhartidde.com/ //https://localhost:44329/
        fetch('https://ums.subhartidde.com//api/ChatBot', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                question: question,
                user: finallocation,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.log('Question saved successfully:', data);
            })
            .catch((error) => {
                console.error('Error saving question:', error);
            });
    }
    //test

    //test

    addMessageWithAnimation(content: string, isUser: boolean) {
        const newMessage = {
            content: '',
            isUser,
            isTyping: true,
        };
        this.messages.push(newMessage);
        this.scrollToBottom();
        this.changeDetectorRef.detectChanges();

        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < content.length) {
                newMessage.content = content.substring(0, i + 1);
                i++;
                this.scrollToBottom();
                this.changeDetectorRef.detectChanges();
            } else {
                newMessage.isTyping = false;
                clearInterval(typingInterval);
                this.changeDetectorRef.detectChanges();
            }
        }, 20);
    }
    sendMessage() {
        const query = this.currentInput.trim();
        if (!query) return;

        this.addMessageWithAnimation(query, true);
        this.currentInput = '';
        this.userInput.nativeElement.value = '';
        this.keepSuggestions = false; // Clear suggestions after sending
        this.relatedQuestions = [];
        this.changeDetectorRef.detectChanges();

        setTimeout(() => {
            const answer = this.getAnswer(query);
            this.addMessageWithAnimation(answer, false);
        }, 500);
    }
    onInputFocus() {
        // Show suggestions again when input is focused
        if (this.currentInput.length >= this.minCharsForSuggestions) {
            this.updateSuggestions(this.currentInput);
        }
        this.keepSuggestions = true;
        this.changeDetectorRef.detectChanges();
    }

    onInputBlur() {
        // Don't clear suggestions immediately on blur
        setTimeout(() => {
            if (!this.keepSuggestions) {
                this.relatedQuestions = [];
                this.changeDetectorRef.detectChanges();
            }
        }, 200);
    }

    typeMessage(fullText: string, isUser: boolean) {
        const newMessage = {
            content: '',
            isUser,
            isTyping: true,
        };
        this.messages.push(newMessage);
        this.scrollToBottom();
        this.changeDetectorRef.detectChanges();

        let i = 0;
        const typingInterval = setInterval(() => {
            if (i < fullText.length) {
                newMessage.content = fullText.substring(0, i + 1);
                i++;
                this.scrollToBottom();
                this.changeDetectorRef.detectChanges();
            } else {
                newMessage.isTyping = false;
                clearInterval(typingInterval);
                this.changeDetectorRef.detectChanges();
            }
        }, 20);
    }
    addMessage(content: string, isUser: boolean, isTyping: boolean = false) {
        this.messages.push({ content, isUser, isTyping });
        this.scrollToBottom();
        this.changeDetectorRef.detectChanges();
    }

    getAnswer(query: string): string {
        const normalizedQuery = this.normalizeText(query);
        const langField = this.showHindi ? 'questionHindi' : 'question';
        const answerField = this.showHindi ? 'answerHindi' : 'answer';

        // Find best matching question with scoring
        const found = this.qaList
            .map((item) => {
                const currentLangText = this.normalizeText(item[langField]);
                const alternateLangText = this.normalizeText(
                    this.showHindi ? item.question : item.questionHindi
                );

                let score = 0;

                if (currentLangText === normalizedQuery) score += 100;
                if (alternateLangText === normalizedQuery) score += 80;
                if (currentLangText.includes(normalizedQuery)) score += 30;
                if (alternateLangText.includes(normalizedQuery)) score += 20;

                return { ...item, score };
            })
            .sort((a, b) => b.score - a.score)
            .find((item) => item.score > 0);

        if (found) {
            // Return answer in current language if available
            if (found[answerField]) {
                return found[answerField];
            }
            // Fallback to English answer if Hindi answer missing
            if (this.showHindi && found['answer']) {
                return found['answer'];
            }
            // Fallback to Hindi answer if English answer missing
            if (!this.showHindi && found['answerHindi']) {
                return found['answerHindi'];
            }
        }

        // Final fallback message
        return this.showHindi
            ? 'मुझे इस प्रश्न का उत्तर नहीं मिला। कृपया कोई अन्य प्रश्न पूछें।'
            : "I couldn't find an answer. Please ask something else.";
    }

    scrollToBottom() {
        setTimeout(() => {
            try {
                this.chatBox.nativeElement.scrollTop =
                    this.chatBox.nativeElement.scrollHeight;
            } catch (err) {
                console.error('Scroll error:', err);
            }
        }, 100);
    }

    toggleLanguage() {
        this.showHindi = !this.showHindi;
        this.relatedQuestions = [];
        this.updateWelcomeMessage();
        this.changeDetectorRef.detectChanges();
    }
}
